import React from 'react';
import { inputStyles } from './shared/FormStyles';
import { navigatetoHome } from '@/utils/footer-navigations';

const RestrictedFeatureOverlay = () => (
  <div 
    className="absolute inset-0 rounded-lg"
    style={{
      background: 'linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(249,250,251,0.95) 100%)',
      backdropFilter: 'blur(2px)'
    }}
  >
    <div className="flex h-full flex-col items-center justify-center p-4 text-center">
      <span className="text-2xl mb-2">🎨</span>
      <p className="text-sm font-medium text-gray-900 mb-1">
        Premium Feature
      </p>
      <p className="text-xs text-gray-500">
        Upgrade to customize barcode colors
      </p>
      <button 
        className="mt-3 px-4 py-1.5 bg-blue-500 text-white text-sm font-medium rounded-full 
                   hover:bg-blue-600 transition-colors"
        onClick={() => navigatetoHome('/#prices')}
      >
        Upgrade Now
      </button>
    </div>
  </div>
);

const BarcodeSettingsForm = ({ settings, onBarcodeSettingChange, plan }) => {
  const handleColorChange = (property, value) => {
    onBarcodeSettingChange(property, value);
  };

  return (
    <div className={inputStyles.container}>
      <div className="relative">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block">
              <span className={inputStyles.label}>Barcode Color</span>
              <div className="mt-2 flex items-center gap-3">
                <input
                  type="color"
                  className={inputStyles.colorInput}
                  value={settings.color}
                  onChange={(e) => handleColorChange('color', e.target.value)}
                  disabled={plan === 'basic'}
                />
                <span className="text-sm text-gray-500">{settings.color}</span>
              </div>
            </label>
          </div>

          <div>
            <label className="block">
              <span className={inputStyles.label}>Background</span>
              <div className="mt-2 flex items-center gap-3">
                <input
                  type="color"
                  className={inputStyles.colorInput}
                  value={settings.bgColor}
                  onChange={(e) => handleColorChange('bgColor', e.target.value)}
                  disabled={plan === 'basic'}
                />
                <span className="text-sm text-gray-500">{settings.bgColor}</span>
              </div>
            </label>
          </div>
        </div>

        {plan === 'basic' && <RestrictedFeatureOverlay />}
      </div>
    </div>
  );
};

export default BarcodeSettingsForm;
